import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import hpeBgImg from "../assets/hpe-bg.jpg";
import {
  callApiPostJson,
  callApiText,
  injectStyle,
  release,
  logAccess,
  callApiGetJson,
  APIServerURL,
  callApiValidatePort,
  envKey,
  validateEmail,
  validatePassword
} from "./GlobalSettings";
import { showToast } from "../common/UtilityHelper";

class CustomerResetPassword extends Component {

    constructor(props){
        super(props);

        this.state = {
            cust_password: undefined,
            cust_confirm_password: undefined,
            showResetLoader: false,
            ResetMessage: undefined,
            isResetSuccess: false
        }

        this._handleresetPwdChange = this._handleresetPwdChange.bind(this);
        this._handleresetPwdConfirmChange = this._handleresetPwdConfirmChange.bind(this);
        this._handleresetSubmit = this._handleresetSubmit.bind(this);


    }

    componentDidMount(){

    }

    _handleresetSubmit(){
        if(this.state.cust_confirm_password && this.state.cust_password && this.state.cust_password === this.state.cust_confirm_password){
            if(this.state.cust_password.length > 4 && this.state.cust_confirm_password.length > 4){

                console.log('Submit password reset starting');
                this.setState({showResetLoader: true});
                var endpoint =  '/Account/HPECustomerPwdUpdate';
                var postData = { "Password": this.state.cust_password, "Guid": this.props.GUIDVal };
                let token = "n/a";
        
                callApiPostJson(endpoint, postData, token).then(data =>{
                    console.log('ResetHPEPassport data:');
                    console.log(data);
        
                    if(data && data.ResetPassportSrvMessage && data.ResetPassportSrvMessage[0].indexOf("Password changed successfully") >= 0)
                    {
                        this.setState({
                            showResetLoader: false,                            
                            ResetMessage: data.ResetPassportSrvMessage[0],
                            isResetSuccess: true
                        });
                        showToast({
                            message: data.ResetPassportSrvMessage[0],
                            intent: "success",
                          });
                    }
                    else {
                        this.setState({
                            showResetLoader: false,                            
                            ResetMessage: data.ResetPassportSrvMessage[0] ? data.ResetPassportSrvMessage[0] : "Reset of Password failed at Passport Server, Please  try strong Password",
                            isResetSuccess: false
                        });
                        showToast({
                            message: data.ResetPassportSrvMessage[0] ? data.ResetPassportSrvMessage[0] : "Reset of Password failed at Passport Server, Please  try strong Password",
                            intent: "danger",
                          });
                    }
                });
            }
        }
    }

    _handleresetPwdChange(event){
        this.setState({cust_password: event.target.value});
    }

    _handleresetPwdConfirmChange(event){
        this.setState({cust_confirm_password: event.target.value});
    }

    render(){

        var NewPwd = this.state.cust_password;
        var ConfmPwd = this.state.cust_confirm_password;

        var DisableTobe = true;
        if(this.state.cust_confirm_password && this.state.cust_password && this.state.cust_password === this.state.cust_confirm_password){
            if(this.state.cust_password.length > 4 && this.state.cust_confirm_password.length > 4){
                DisableTobe = false;
            }
        }
        var spinnerContent = "";

        if(this.state.showResetLoader){
            spinnerContent = (
                <Layer position="center">
                  <Box
                    align="center"
                    direction="row"
                    gap="small"
                    pad="small"
                    key="small"
                  >
                    <Spinner size="large" />
                    <Text size="large">Reset New Password in Progress...</Text>
                  </Box>
                </Layer>
              );
        }

        return(
            <Layer full="true" position="center">
            <Box fill="vertical" align="stretch" justify="start">
            <Main overflow="auto" background={{image: `url(${hpeBgImg})`, color:"background", dark:true}} flex align="center" justify="center">
            <Box align="center" justify="start" background={{"color":"background","dark":false}} pad="medium" round="xsmall" gap="medium">
              <Heading level="1" size="small" margin="none">
                HPE Demonstration Portal
              </Heading>
              <Box align="center" justify="center" gap="none">
                <Paragraph margin="xsmall">
                  You're almost finished resetting your HPE Passport credentials! .
                </Paragraph>
                <Paragraph margin="xsmall">
                  Please provide your new password, verify it one more time, and then submit to finalize your password reset.
                </Paragraph>
              </Box>
              <Box align="start" justify="center" gap="none">
                <Text>
                  New Password
                </Text>
                <TextInput placeholder="New Password" type="password" value={NewPwd} onChange={this._handleresetPwdChange} />
              </Box>
              <Box align="start" justify="center" gap="none">
                <Text>
                  Confirm New Password
                </Text>
                <TextInput placeholder="Confirm Password" type="password" value={ConfmPwd} onChange={this._handleresetPwdConfirmChange} />
              </Box>
              {spinnerContent}
              <Box align="center" justify="center" gap="medium" direction="row">
                <Button label="Set Password" primary disabled = {DisableTobe} onClick={this._handleresetSubmit}/>
              </Box>
            </Box>
          </Main>
        </Box>
        </Layer>
        )
    }
}

export default CustomerResetPassword;